import { Box } from '@coolblue-development/freddy';
import showAccessoryProductsTrigger from '@coolblue-development/ga4-events/triggers/OptionsRow/showAccessoryProductsTrigger';
import viewTrigger from '@coolblue-development/ga4-events/triggers/OptionsRow/viewTrigger';
import { TrackImmediate, TrackWhenVisible } from '@coolblue-development/next-analytics/client';
import useDefaultContentToOptionsRowSection from '@features/add-to-cart-page/components/Sections/defaultOptionsRowSectionTextComposer';
import OptionsRow from '@features/add-to-cart-page/components/Sections/OptionsRow/OptionsRow';
import SectionTitle from '@features/add-to-cart-page/components/SectionTitle/SectionTitle';
import { ATCPageOptionsRowSection } from '@features/add-to-cart-page/typings/OptionsRowSection';
import { getAddToCartPageType } from '@features/add-to-cart-page/utils/getAddToCartPageType';
import { mapSlotsToProducts } from '@features/add-to-cart-page/utils/optionsRowSection';
import useTestId from '@hooks/useTestId';

import { AddToCartPageSectionProps } from '../../typings/AddToCartPageSection';

export function ManualOptionsRowSection({
  product,
  section,
  order,
  isBusiness
}: AddToCartPageSectionProps) {
  const addToCartPageType = getAddToCartPageType({ isBusiness });
  const manualOptionsRowSection = section as ATCPageOptionsRowSection;
  const testId = useTestId('options-row-section-title');

  const sectionWithDefaults = useDefaultContentToOptionsRowSection(manualOptionsRowSection);

  const productIds = mapSlotsToProducts(sectionWithDefaults.slots);

  const trackImmediateParams = {
    sub_feature: addToCartPageType,
    primary_item_id: product.id,
    is_fallback: sectionWithDefaults.isFallback,
    attached_item_ids: productIds
  };

  const trackWhenVisibleParams = {
    item_ids: productIds
  };

  return (
    <Box {...testId} mt={800} component='section'>
      <TrackImmediate trigger={showAccessoryProductsTrigger(trackImmediateParams)} />
      <TrackWhenVisible trigger={viewTrigger(trackWhenVisibleParams)}>
        <SectionTitle title={sectionWithDefaults.title} index={order} />
        <OptionsRow
          {...sectionWithDefaults}
          mainProductId={product.id}
          addToCartPageType={addToCartPageType}
        />
      </TrackWhenVisible>
    </Box>
  );
}
